define.alias("shared/components/shared/ui/switcher/item", "preview-grid/components/shared/ui/switcher/item");